import { render, staticRenderFns } from "./UpdateCredential.vue?vue&type=template&id=032b3321"
import script from "./UpdateCredential.vue?vue&type=script&lang=js"
export * from "./UpdateCredential.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports